import { FormControl, Flex, FormLabel, Tooltip, Box, Input } from '@chakra-ui/react';
import { UilQuestionCircle } from '@iconscout/react-unicons';

function setProjectAccountName({ e, projectInfo, setProjectInfo, setAccountNameValid }) {
	setAccountNameValid(true);
	const value = e.target.value;
	const newProjectInfo = { ...projectInfo };
	newProjectInfo.accountName = value;
	setProjectInfo(newProjectInfo);
}

const CreateSaveProjectAccountName = ({ projectInfo, setProjectInfo, accountNameValid, setAccountNameValid }) => {
	return (
		<FormControl maxW="50%" mb={6}>
			<Flex mb={2} alignItems={'end'}>
				<FormLabel mb={0} mr={1} fontWeight="bold" fontSize={'xs'}>
					Account Name
				</FormLabel>
				<Tooltip
					fontSize="xs"
					label="O accountName Vtex da loja. Este dado é obrigatório para a gerar os arquivos da loja. Você pode alterar este campo posteriormente. "
				>
					<Box>
						<UilQuestionCircle size="16" />
					</Box>
				</Tooltip>
			</Flex>
			<Input
				isInvalid={!accountNameValid}
				defaultValue={projectInfo.accountName ? projectInfo.accountName : ''}
				onChange={(e) => setProjectAccountName({ e, projectInfo, setProjectInfo, setAccountNameValid })}
				size="sm"
				h={8}
			/>
		</FormControl>
	);
};

export default CreateSaveProjectAccountName;
